export const getCaptchaToken = async (): Promise<string | null> => {
  const captchaKey = import.meta.env.VITE_GOOGLE_CAPTCHA_KEY;
  if (!captchaKey || !window.grecaptcha?.enterprise) {
    return null;
  }

  try {
    const token = await window.grecaptcha.enterprise.execute(captchaKey, {
      action: "submit",
    });
    return token;
  } catch (error) {
    console.error("Captcha execution failed", error);
    return null;
  }
};
